<template>
  <div class="footerBox">
    <div class="app-container">
      <div class="contentBox footer flex clearFlex">
        <div class="lh-f-details">
          <div class="flex clearFlex">
            <div class="lh-f-company">
              <p>公司</p>
              <ul class="infoBox">
                <li><a href="https://about.ipaiban.com/" target="_blank" title="i排版编辑器">关于我们</a></li>
                <li><a href="https://jobs.ipaiban.com/" target="_blank" title="i排版编辑器">人才招聘</a></li>
                <li><a href="https://contact.ipaiban.com/" target="_blank" title="i排版编辑器">联系我们</a></li>
                <li><router-link to="/helpCenter">帮助中心</router-link></li>
              </ul>
            </div>
            <div class="lh-f-server">
              <p>服务</p>
              <ul class="infoBox">
                <li><a href="http://ipaiban.com" target="_blank" title="i排版编辑器">i排版</a></li>
                <li><a href="http://ipaiban.com/detail/fans.html" target="_blank" title="i排版编辑器">微信加粉</a></li>
                <!--<li><a href="http://ipaiban.com/detail/promotion.html" target="_blank">知乎营销</a></li>-->
                <li><a href="http://a.playhudong.com/" target="_blank">灵猴变现</a></li>
              </ul>
            </div>
            <div class="lh-f-link">
              <p>联系</p>
              <ul class="infoBox2">
                <li>微信：Playhudong011</li>
                <li>邮箱：i@playhudong.com</li>
                <!--<li>地址：北京市西城区西直门南大街2号成铭大厦D座8层（西直门地跌站c东南口出)</li>-->
              </ul>
            </div>
          </div>
          <p class="police"><a href="https://beian.miit.gov.cn/" target="_blank">京ICP备14043207号-1</a>&nbsp;&nbsp;&nbsp;&nbsp;<br class="media"><img src="../../static/image/beian.png" alt="i排版编辑器"><a href="https://beian.miit.gov.cn/">京公安网备11010802023272号</a>&nbsp;&nbsp;&nbsp;&nbsp;<br class="media">&copy;{{ new Date().getFullYear() }}小黄人科技&nbsp;&nbsp;<br class="media"><router-link to="/agreement">服务协议</router-link>
          </p>
        </div>
        <div class="lh-f-qcode ">
          <p class="official-accounts">公众号</p>
          <div class="flex qcode-container">
            <div class="qcode-VLD">
              <img :src="imgArr[0]" alt="i排版编辑器">
              <p class="p3">灵猴服务</p>
              <p class="p3">linghouVIP</p>
              <p class="p3">新媒体一站式营销服务平台</p>
            </div>
            <div class="qcode-XH">
              <img :src="imgArr[1]" alt="i排版编辑器">
              <p class="p3">小黄人科技</p>
              <p class="p3">PlayHuDong</p>
              <p class="p3">i排版注册登录与运营知识</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Footer',
  data () {
    return {
      imgArr: ['./static/image/lh.jpg', './static/image/qr-code-2.jpg']
    }
  }
}
</script>
<style scoped lang="less">
  .footerBox {
    width: 100%;
    height: 200px;
    background: #3D4A67;
    padding: 100px 0;
    @media screen and (max-width:768px){
      padding: 20px 0;
      height: auto;
    }
    .lh-f-details {
      flex: 1;
      .lh-f-company, .lh-f-server, .lh-f-link {
        flex: 1;
         @media screen and (max-width:768px){
          text-align: center;
          padding:0 20px;
          }
        p {
          margin-bottom: 20px;
          color: #949bab;
          font-size: 16px;
          @media screen and (max-width:768px){
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 14px;
          }
        }
        li {
          margin-bottom: 10px;
          color: #e2e4e8;
           font-size: 14px;
          @media screen and (max-width:768px){
            font-size: 12px;
          }
          a {
            text-decoration: none;
            color: #e2e4e8;
            font-size: 14px;
            @media screen and (max-width:768px){
            margin-top: 10px;
            margin-bottom: 10px;
            font-size: 12px;
          }
          }
        }
      }
      .police {
        margin-top: 29px;
        color: #e2e4e8;
        font-size: 14px;
        @media screen and (max-width:768px){
        text-align: center;
        padding:0 20px;
        font-size: 12px;
        line-height: 25px;
        }
        img{
          vertical-align: middle;
          @media screen and (max-width:768px){
            width: 16px;
          }
        }
      }
      a{
        color: #e2e4e8;
      }
    }
    .lh-f-qcode {
      flex: 1;
       @media screen and (max-width:768px){
        text-align: center;
        padding:0 20px;
      }
      .official-accounts {
        color: #949bab;
        padding-left: 237px;
        @media screen and (max-width:768px){
        text-align: center;
         padding-left: 0;
         margin-top: 20px;
         font-size: 14px;
      }
      }
      img {
        width: 100px;
        height: 100px;
      }
      .qcode-container {
        padding-top: 20px;
        padding-left: 200px;
        @media screen and (max-width:768px){
        text-align: center;
         padding-left: 0;
      }
        .p3{
          margin-top: 4.5px;
        }
        p {
          color: #e2e4e8;
          font-size: 14px;
        @media screen and (max-width:768px){
          font-size: 12px;
        }
        }
      }
      .qcode-VLD {
        float: left;
        width: 180px;
        text-align: center;
      }
      .qcode-XH {
        float: left;
        width: 180px;
        text-align: center;
      }
    }
    .clearFlex{
    @media screen and (max-width:768px){
      display: block
    }
    }
  }
  .infoBox{
    @media screen and (max-width:768px){
      display: flex;
      justify-content: space-around
    }
  }
 .media{
    display: none;
    @media screen and (max-width:768px){
      display: block
    }
 }

</style>



// WEBPACK FOOTER //
// src/components/Footer.vue